import { useIntl } from 'react-intl';

import {
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@/components/Table/Table';
import { useIsMdDown } from '@/hooks/useMedia';
import { STATICIMAGES_PATH_PREFIX } from '@/lib/const';
import * as M from '@/messages/strapsBuckle';

import type { BuckleDataType } from './const';
import { buckleTableList } from './const';

import * as S from './PlaceholderBuckleTable.styles';
export const PlaceholderBuckleTable = () => {
  const { formatMessage } = useIntl();
  const renderMessages = (key: string, type: string) => {
    const id = `${key}${type}`;
    return (
      M.bucklesMessages[id as keyof typeof M.bucklesMessages] ??
      M.bucklesMessages.elegant
    );
  };
  const isMobileView = useIsMdDown();
  const renderBuckleGroup = (buckle: BuckleDataType) => {
    const mobileImageUrl = buckle.images.sporty ?? buckle.images.elegant;
    return isMobileView ? (
      <S.BuckleTableCell align='center'>
        <S.Media>
          <S.Image
            alt={`${buckle.key} mobile`}
            className='default'
            data-test-id='BuckleSportyImage'
            height={0}
            loading='lazy'
            src={STATICIMAGES_PATH_PREFIX + mobileImageUrl}
            width={0}
          />
        </S.Media>
      </S.BuckleTableCell>
    ) : (
      <>
        <S.BuckleTableCell align='center'>
          {buckle.images.elegant && (
            <S.Media>
              <S.Image
                alt={`${buckle.key} Elegant`}
                className='default'
                data-test-id='BuckleElegantImage'
                height={0}
                loading='lazy'
                src={STATICIMAGES_PATH_PREFIX + buckle.images.elegant}
                width={0}
              />
            </S.Media>
          )}
        </S.BuckleTableCell>
        <S.BuckleTableCell align='center'>
          {buckle.images.sporty && (
            <S.Media>
              <S.Image
                alt={`${buckle.key} Sporty`}
                className='default'
                data-test-id='BuckleSportyImage'
                height={0}
                loading='lazy'
                src={STATICIMAGES_PATH_PREFIX + buckle.images.sporty}
                width={0}
              />
            </S.Media>
          )}
        </S.BuckleTableCell>
      </>
    );
  };

  const renderMobileTable = (type: string) => {
    const mobileElegantBuckleList = buckleTableList.filter(
      (item) => item.images.elegant,
    );
    const mobileSportyBuckleList = buckleTableList.filter(
      (item) => item.images.sporty,
    );
    const buckleList =
      type === 'elegant' ? mobileElegantBuckleList : mobileSportyBuckleList;
    return (
      <Table>
        <TableHead>
          <TableRow>
            <S.BuckleTableCell align='center' component='th' scope='col'>
              <S.Title textTransform='uppercase'>
                {formatMessage(
                  M.bucklesMessages[type as keyof typeof M.bucklesMessages],
                )}
              </S.Title>
            </S.BuckleTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {buckleList.map((buckle) => (
            <TableRow key={buckle.key}>
              <S.MobileBuckleTableCell>
                <S.MobileBuckleTitle>
                  <S.Title scale='p3' textTransform='uppercase'>
                    {formatMessage(renderMessages(buckle.key, 'Title'))}
                  </S.Title>
                </S.MobileBuckleTitle>
                <S.MobileBuckleInfoBox>
                  <S.MobileBuckleRowBox>
                    <S.Media>
                      <S.Image
                        alt={`${buckle.key} Elegant`}
                        className='default'
                        data-test-id='CaliberImage'
                        height='0'
                        width='0'
                        loading='lazy'
                        src={
                          STATICIMAGES_PATH_PREFIX +
                          buckle.images[type as keyof typeof buckle.images]
                        }
                      />
                    </S.Media>
                  </S.MobileBuckleRowBox>
                  <S.MobileBuckleRowBox>
                    <S.Description textTransform='uppercase'>
                      {formatMessage(renderMessages(buckle.key, 'Description'))}
                    </S.Description>
                  </S.MobileBuckleRowBox>
                </S.MobileBuckleInfoBox>
              </S.MobileBuckleTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };
  const renderDesktopTable = () => {
    return (
      <Table>
        <S.BuckleHeaderBox>
          <TableRow>
            <S.BuckleTableCell
              align='center'
              component='th'
              scope='col'
            ></S.BuckleTableCell>
            <S.BuckleTableCell align='center' component='th' scope='col'>
              <S.Title textTransform='uppercase'>
                {formatMessage(M.bucklesMessages.elegant)}
              </S.Title>
            </S.BuckleTableCell>
            <S.BuckleTableCell align='center' component='th' scope='col'>
              <S.Title textTransform='uppercase'>
                {formatMessage(M.bucklesMessages.sporty)}
              </S.Title>
            </S.BuckleTableCell>
            <S.BuckleTableCell
              align='center'
              component='th'
              scope='col'
            ></S.BuckleTableCell>
          </TableRow>
        </S.BuckleHeaderBox>
        <TableBody>
          {buckleTableList.map((buckle) => (
            <TableRow key={buckle.key}>
              <S.BuckleTableCell>
                <S.Title scale='p3' textTransform='uppercase'>
                  {formatMessage(renderMessages(buckle.key, 'Title'))}
                </S.Title>
              </S.BuckleTableCell>
              {renderBuckleGroup(buckle)}
              <S.BuckleTableCell>
                <S.Description textTransform='uppercase'>
                  {formatMessage(renderMessages(buckle.key, 'Description'))}
                </S.Description>
              </S.BuckleTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  };
  return (
    <S.Wrapper>
      {isMobileView ? (
        <>
          {renderMobileTable('elegant')}
          {renderMobileTable('sporty')}
        </>
      ) : (
        renderDesktopTable()
      )}
    </S.Wrapper>
  );
};
